import { render, staticRenderFns } from "./TilleredUserCard.vue?vue&type=template&id=f1f63ee2&"
import script from "./TilleredUserCard.vue?vue&type=script&lang=js&"
export * from "./TilleredUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports